import React from "react";
import "./Education.css";
import useScrollReveal from "../../hooks/useScrollReveal";

const educationData = [
  {
    degree: "B.Sc. in Digital Game Design",
    school: "Beykoz University",
    year: "Sep 2022 – Jan 2026",
    gpa: "GPA: 3.63 / 4.0",
    highlights: [
      "High Honor Student (4×) · Top 3 in department (Spring 2023)",
      "Vice President, BUMedya Student Club — creative projects, digital media production, event organization & team coordination",
      "Active contributor to game development, AI for games, UI/UX design, multiplayer systems, and full-stack software projects",
    ],
    skills:
      "Unity · C# · Python · Java · Web Technologies · Databases · Data Structures & Algorithms · Version Control",
  },
];

export default function Education() {
  const sectionRef = useScrollReveal();

  return (
    <section id="education" className="section" ref={sectionRef}>
      <h2 className="section-title">Education</h2>
      <div className="edu-timeline">
        {educationData.map((item, idx) => (
          <div key={idx} className={`edu-item ${idx % 2 === 0 ? "left" : "right"}`}>
            <div className="edu-dot" />
            <div className="edu-content">
              <h3 className="edu-degree">{item.degree}</h3>
              <div className="edu-meta">
                <span className="edu-school">{item.school}</span>
                <span className="edu-sep">•</span>
                <time className="edu-year">{item.year}</time>
                <span className="edu-sep">•</span>
                <span className="edu-gpa">{item.gpa}</span>
              </div>
              <ul className="edu-highlights">
                {item.highlights.map((h, i) => (
                  <li key={i}>{h}</li>
                ))}
              </ul>
              {item.skills && (
                <p className="edu-skills">{item.skills}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
